module.exports = __webpack_public_path__ + "img/zdcx_1.e67920c7.png";